export const materialReadinessLabels = {
  "en": {
    "title": "Material readiness preview",
    "check": "Check saved extraction",
    "pending": "Checking…",
    "note": "Checks saved extraction metadata only. Review the source before use; this does not assess accuracy or academic quality.",
    "failed": "Preview unavailable. Refresh the material and verify your permissions before retrying.",
    "available": "Saved text is available",
    "empty": "Saved text is empty",
    "truncated": "Saved text includes a truncation marker",
    "source": "{{characters}} characters · Extraction revision {{revision}}",
    "legacy_shared": "Legacy shared material; ownership has not been assigned.",
    "tenant_private": "Material belongs to the active institution.",
    "receipt": "Preview reference: {{id}}"
  },
  "fr": {
    "title": "Vérification du document",
    "check": "Vérifier le texte enregistré",
    "pending": "Vérification…",
    "note": "Vérifie uniquement les métadonnées du texte extrait. Examinez la source avant utilisation ; la précision et la qualité pédagogique ne sont pas évaluées.",
    "failed": "Vérification indisponible. Actualisez le document et vérifiez vos autorisations avant de réessayer.",
    "available": "Un texte enregistré est disponible",
    "empty": "Le texte enregistré est vide",
    "truncated": "Le texte enregistré contient un indicateur de troncature",
    "source": "{{characters}} caractères · Révision de l’extraction {{revision}}",
    "legacy_shared": "Document partagé historique ; propriétaire non attribué.",
    "tenant_private": "Le document appartient à l’établissement actif.",
    "receipt": "Référence de vérification : {{id}}"
  },
  "hu": {
    "title": "Tananyag ellenőrzése",
    "check": "Mentett szöveg ellenőrzése",
    "pending": "Ellenőrzés…",
    "note": "Csak a mentett szövegkinyerés metaadatait ellenőrzi. Használat előtt tekintse át a forrást; a pontosságot és a szakmai minőséget nem értékeli.",
    "failed": "Az ellenőrzés nem érhető el. Frissítse a tananyagot, és ellenőrizze jogosultságait az újrapróbálás előtt.",
    "available": "Mentett szöveg elérhető",
    "empty": "A mentett szöveg üres",
    "truncated": "A mentett szöveg csonkolásjelölőt tartalmaz",
    "source": "{{characters}} karakter · Kinyerési verzió: {{revision}}",
    "legacy_shared": "Korábbi megosztott tananyag; nincs hozzárendelt tulajdonos.",
    "tenant_private": "A tananyag az aktív intézményhez tartozik.",
    "receipt": "Ellenőrzés hivatkozása: {{id}}"
  },
  "ru": {
    "title": "Проверка материала",
    "check": "Проверить сохранённый текст",
    "pending": "Проверка…",
    "note": "Проверяются только метаданные извлечённого текста. Изучите источник перед использованием; точность и академическое качество не оцениваются.",
    "failed": "Проверка недоступна. Обновите материал и проверьте права доступа перед повторной попыткой.",
    "available": "Сохранённый текст доступен",
    "empty": "Сохранённый текст пуст",
    "truncated": "Сохранённый текст содержит отметку об усечении",
    "source": "{{characters}} символов · Версия извлечения {{revision}}",
    "legacy_shared": "Ранее опубликованный общий материал; владелец не назначен.",
    "tenant_private": "Материал принадлежит активному учреждению.",
    "receipt": "Ссылка на проверку: {{id}}"
  },
  "de": {
    "title": "Materialprüfung",
    "check": "Gespeicherten Text prüfen",
    "pending": "Prüfung…",
    "note": "Prüft nur Metadaten der gespeicherten Textextraktion. Prüfen Sie die Quelle vor der Verwendung; Genauigkeit und fachliche Qualität werden nicht bewertet.",
    "failed": "Prüfung nicht verfügbar. Aktualisieren Sie das Material und prüfen Sie Ihre Berechtigungen vor einem neuen Versuch.",
    "available": "Gespeicherter Text ist verfügbar",
    "empty": "Der gespeicherte Text ist leer",
    "truncated": "Der gespeicherte Text enthält eine Kürzungsmarkierung",
    "source": "{{characters}} Zeichen · Extraktionsversion {{revision}}",
    "legacy_shared": "Älteres gemeinsam genutztes Material; Eigentümer noch nicht zugewiesen.",
    "tenant_private": "Das Material gehört zur aktiven Einrichtung.",
    "receipt": "Prüfreferenz: {{id}}"
  }
};
